import React, { useState, useEffect } from "react";
import axios from "../../api/axios";
import { useSelector } from "react-redux";
import { translations, normalizeLang } from "../../i18n";

const SendSms = () => {
  const [message, setMessage] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [awaitingReply, setAwaitingReply] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const user = useSelector((state) => state.user.data);
  

  const lang = normalizeLang(user?.languageCode);
  const t = translations[lang];

  useEffect(() => {
    if (awaitingReply) {
      const t = setTimeout(() => setAwaitingReply(false), 2000);
      return () => clearTimeout(t);
    }
  }, [awaitingReply]);

  const handleSend = async () => {
    setErrorMsg("");

    if (!message.trim()) return;
    if (isSending) return;
    if (awaitingReply) {
      setErrorMsg(t.alreadySentError);
      return;
    }

    setIsSending(true);
    const initData = window.Telegram.WebApp.initData;

    try {
      await axios.post(
        "/api/user/message",
        { message: message.replace(/[<>&"']/g, "") },
        {
          headers: {
            "X-Telegram-Init-Data": initData,
          },
        }
      );
      setAwaitingReply(true);
      setMessage("");
    } catch (error) {
      console.error("Ошибка:", error);
      setErrorMsg(t.sendFailError);
    } finally {
      setIsSending(false);
    }
  };

  const canSend = Boolean(message.trim()) && !isSending && !awaitingReply;

  return (
    <div>
      <div style={{ fontSize: "11px", margin: "0 15px", display: "flex" }}>
        <svg
          style={{ marginRight: "5px" }}
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 0C3.35775 0 0 3.35775 0 7.5C0 8.454 0.196496 9.42075 0.539246 10.2892L1.125 11.484C1.49625 12.2557 1.36575 12.9832 0.867004 13.875C0.591754 14.3685 0.93525 14.9632 1.5 14.9767C2.26275 14.994 3.53025 14.751 4.5 14.391C5.3955 14.8043 6.501 15 7.5 15C11.6423 15 15 11.6423 15 7.5C15 3.35775 11.6423 0 7.5 0ZM7.5 1.5C10.8135 1.5 13.5 4.1865 13.5 7.5C13.5 10.8135 10.8135 13.5 7.5 13.5C6.6375 13.5 5.55375 13.278 4.875 12.9142C4.674 12.8062 4.428 12.7778 4.21875 12.867C3.74025 13.0718 3.25725 13.2255 2.6955 13.3358C2.9205 12.5475 2.85375 11.6453 2.46075 10.8285L1.89825 9.6795C1.6485 9.0405 1.5 8.265 1.5 7.5C1.5 4.1865 4.1865 1.5 7.5 1.5ZM4.5 6.75C4.086 6.75 3.75 7.086 3.75 7.5C3.75 7.914 4.086 8.25 4.5 8.25C4.914 8.25 5.25 7.914 5.25 7.5C5.25 7.086 4.914 6.75 4.5 6.75ZM7.5 6.75C7.086 6.75 6.75 7.086 6.75 7.5C6.75 7.914 7.086 8.25 7.5 8.25C7.914 8.25 8.25 7.914 8.25 7.5C8.25 7.086 7.914 6.75 7.5 6.75ZM10.5 6.75C10.086 6.75 9.75 7.086 9.75 7.5C9.75 7.914 10.086 8.25 10.5 8.25C10.914 8.25 11.25 7.914 11.25 7.5C11.25 7.086 10.914 6.75 10.5 6.75Z"
            fill="black"
            fillOpacity="0.85"
          />
        </svg>
        <p>{t.infoText}</p>
      </div>

      <div
        style={{
          border: "solid 1px #F2F2F2",
          margin: "15px",
          borderRadius: "8px",
          height: "77px",
        }}
      >
        <input
          style={{ width: "100%", padding: "10px", fontSize: "12px" }}
          placeholder={t.placeholder}
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          disabled={awaitingReply || isSending}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            margin: "0 8px 8px",
            cursor: canSend ? "pointer" : "not-allowed",
            opacity: canSend ? 1 : 0.4,
            pointerEvents: canSend ? "auto" : "none",
          }}
          onClick={handleSend}
        >
          <svg
            width="31"
            height="31"
            viewBox="0 0 31 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="31" height="31" rx="15.5" fill="#366091" />
            <path
              d="M10.7021 13.1023L15.4998 8.30469M15.4998 8.30469L20.2974 13.1023M15.4998 8.30469V22.6975"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        {awaitingReply && (
          <p
            style={{
              fontSize: "10px",
              margin: "0 10px 5px",
              color: "#366091",
              textAlign: "center",
              paddingTop: "10px",
            }}
          >
            {t.sentStatus}
          </p>
        )}
        {errorMsg && (
          <p style={{ fontSize: "10px", margin: "0 10px 5px", color: "red" }}>
            {errorMsg}
          </p>
        )}
      </div>
    </div>
  );
};

export default SendSms;
